// extracted by mini-css-extract-plugin
export default {"divider":"G4NrNlIpqdKRwRklZDon"};